import { makeStyles } from "@material-ui/styles";

export default makeStyles({
  tableTitle: {
    fontWeight: "bold",
    fontSize: 16,
    marginTop: 50,
    paddingBottom: "0.85rem",
    borderBottom: "1px solid #dee2e6",
  },
  
  celdaTabla: {
    padding: "10px 0px 10px 0px",
  },
  
  celdaFecha: {
    padding: "10px 0px 10px 0px",
    width: 100
  },
  
  botonBorrar: {
    padding: '7px 0px 0px 0px'
  }
});
